module.exports = __webpack_public_path__ + "static/media/5.question_loop.7c31f991.mp4";